export { default } from './FooterCompany';
